import React, { useEffect } from "react";
import { IonButtons, IonContent, IonHeader, IonMenuButton, IonPage, IonTitle, IonToolbar, IonButton, IonInput } from "@ionic/react";
import { useParams } from "react-router";
import { useState } from "react";
import "./EmailPasswordResetPage.css";

import classAppHeaderImage from "../assets/reset-password-header.png";
import classAppHeaderImageCanada from "../assets/reset-password-header.canada02.png";


const EmailPasswordResetPage: React.FC = () => {
  const [email, setEmail] = useState<string>("");
  const [message, setMessage] = useState<string>("");
  const [emailValid, setEmailValid] = useState<boolean>(false);
  const [isErrorMessage, setIsErrorMessage] = useState<boolean>(false);

  useEffect(() => {
    validateEmail(email);
  }, [email]);

  const isCanada = window.location.origin.includes(".ca") || window.location.origin.includes("canada");

  async function sendPasswordResetEmail() {
    try {
      let url = "https://class.aimernginx.co.uk/pwb/requestPasswordEmail";
      if (isCanada) {
        url = "https://classcanadainstance1.class-services.ca/classapi/SF/requestPasswordResetEmail";
      }

      const response = await fetch(url, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ email }),
      });

      if (response) {
        const data = await response.json();
        if (data.success || response.status === 200) {
          setIsErrorMessage(false);
          setMessage(data.message);
        } else {
          setIsErrorMessage(true);
          setMessage(data.error);
        }
      } else {
        setIsErrorMessage(true);
        setMessage("Failed to send password reset email");
      }
    } catch (error) {
      setIsErrorMessage(true);
      setMessage("An error occurred while sending the password reset email");
    }
  }

  function validateEmail(email: string) {
    const emailRegex = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/;
    const valid = emailRegex.test(email);
    setEmailValid(valid);
  }

  return (
    <IonPage>
      <IonHeader></IonHeader>

      <IonContent className="email-reset-ion-content" fullscreen>
        <img src={isCanada ? classAppHeaderImageCanada : classAppHeaderImage} />

        <div className="email-reset-main-content">
          <h1 className="email-reset-title">Reset Your App Password</h1>
          <div className="content-text">Please enter your email below to send a reset password link to your email.</div>

          {message ? (
            <div className={`email-reset-message ${isErrorMessage ? "error-message" : ""}`}>{message}</div>
          ) : null}

          <div className="email-input-container">
            <div className="input-label">Email address</div>

            <IonInput
              value={email}
              type="text"
              mode="ios"
              className="input-field"
              onIonInput={(event) => setEmail(event.detail.value!)}
              onKeyDown={(event) => {
                if (event.key === "Enter" && emailValid) {
                  sendPasswordResetEmail();
                }
              }}
            />

            <IonButton className="filled-button send-password-button" disabled={!emailValid} onClick={() => sendPasswordResetEmail()}>
              Send Password Reset Email
            </IonButton>
          </div>

          {isCanada ? (
            <div className="content-text">
              If you have any questions or feedback, please let us know: email <a href="mailto:support@classprofessional.ca">support@classprofessional.ca</a>
            </div>
          ) : (
            <div className="content-text">
              If you have any questions or feedback, please let us know: email <a href="mailto:apps@class.co.uk">apps@class.co.uk</a> or call{" "}
              <a href="tel:01278427800">01278 427800</a>
            </div>
          )}
        </div>
      </IonContent>
    </IonPage>
  );
};

export default EmailPasswordResetPage;
